import { createStore } from '@reduxjs/toolkit';

import reducers from './ducks';

const store = createStore(reducers);

export default store;
